<div fxLayout="row" fxLayoutAlign="space-between start">
  <mat-form-field color="primary" [appearance]="appearance" fxFlex>
    <mat-label [ngClass]="{'color-white': isLableColorWhite}">{{setting.DisplayName}} <span *ngIf="setting.IsMandatory"
      class="validation-red-color">*</span></mat-label>
    <mat-select 
    #multiSelect 
    [sortComparator]="noCompareFunction" 
    attr.data-cy="MultiSelect {{ setting.DisplayName }}" 
    [formControl]="formMultiCtrl" 
    [multiple]="true"
    (closed)="setValue()" 
    (openedChange)="onToggleSelect($event)" 
    [disabled]="isDisable || setting.IsDisableForDay2Manager" 
    (selectionChange)="checkLimit($event.value)"
    >
      <mat-select-trigger *ngIf="isShowCustomLabel">
        <ng-container *ngIf="formMultiCtrl.value">
          <ng-container *ngIf="formMultiCtrl.value.length">
            <mat-chip-list>
              <mat-chip *ngFor="let value of formMultiCtrl.value.slice(0, 5); let i = index;"
              [removable]="true"
              (removed)="removeOption(value)">
                <span class="mr-1" *ngIf="formMultiCtrl.value.length > 1">{{i+1}}.</span> {{getLable(value)}}
                <mat-icon matChipRemove  *ngIf="setting.IsMandatory && options.length > 1">cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>
          </ng-container>
          <ng-container class="mt-1" *ngIf="formMultiCtrl.value.length > 5">
           <span class="inline-count"> (+{{ formMultiCtrl.value.length - 5 }})</span>
          </ng-container>
        </ng-container>
      </mat-select-trigger>
      <mat-option>
        <ngx-mat-select-search
          #selectSearch 
          [placeholderLabel]="setting.DisplayName"
          [showToggleAllCheckbox]="true"
          [searching]="setting.loader"
          [toggleAllCheckboxIndeterminate]="isIndeterminate"
          [toggleAllCheckboxChecked]="isChecked"
          (toggleAll)="toggleSelectAll($event)"
          [formControl]="formMultiFilterCtrl">
        </ngx-mat-select-search>
      </mat-option>
      <ng-container *ngIf="setting.groupOptions; else singleOption">
        <mat-optgroup *ngFor="let option of filteredValuesMulti | async" [label]="option.Label">
          <mat-option class="ml-4" attr.data-cy="MultiSelect Option {{value.Label}}" *ngFor="let value of option.Value" [value]="value.Value">
            {{value.Label}}
          </mat-option>
        </mat-optgroup>
      </ng-container>
      <ng-template #singleOption>
        <mat-option attr.data-cy="MultiSelect Option {{value.Label}}" *ngFor="let value of filteredValuesMulti | async" [value]="value.Value">
          {{value.Label}}
        </mat-option>
      </ng-template>
      <hr>
      <div class="m-1" style="width: 100%;" fxLayout="row" fxLayoutAlign="center center">
        <button attr.data-cy="MultiSelect Cancel {{setting.DisplayName}}" mat-button class="mr-2" (click)="onClose()">
          Cancel
        </button>
        <button class="ml-2" attr.data-cy="MultiSelect Apply {{setting.DisplayName}}" mat-raised-button color="primary" (click)="setValue()">
          Apply
        </button>
      </div>
    </mat-select>
    <mat-icon *ngIf="setting.loader;" matPrefix>
      <mat-spinner color="accent" diameter="20"></mat-spinner>
    </mat-icon>
    <mat-icon color="primary" *ngIf="isShowRefreshButton && !setting.loader;" [icIcon]="icAutoRenew" matPrefix (click)="onClickRefresh()" attr.data-cy="MultiSelect Refresh {{setting.DisplayName}}"></mat-icon>
    <button attr.data-cy="Instruction {{setting.DisplayName}}" type="button" mat-icon-button matSuffix *ngIf="setting.Instructions"
      (click)="$event.stopPropagation();showInfo($event.target, setting.Instructions);">
      <mat-icon color="primary" [icIcon]="icHelp" height="12px" width="12px"></mat-icon>
    </button>
  </mat-form-field>
  <button type="button" *ngIf="setting.ShowAddButton" attr.data-cy="Create App Component" color="primary" mat-mini-fab class="ml-4 text-white" 
  (click)="createAppComponent.emit(setting)">
      <mat-icon [icIcon]="icAdd"></mat-icon>
  </button>
</div>

<blockquote class="blockquote-error mt-0"  *ngIf="isShowError()">
  <p *ngIf="!setting.ParentMissingMessage; else parentMessage">{{setting.DisplayName}} is required</p>
  <ng-template #parentMessage>
    <p >{{setting.ParentMissingMessage}}</p>
  </ng-template>
</blockquote>
